import Colors from "../components/ui-kit/Colors.jsx";
import Shadows from "../components/ui-kit/Shadows.jsx";
import Fonts from "../components/ui-kit/Fonts.jsx";
import Icons from "../components/ui-kit/Icons.jsx";
import MessageInputKit from "../components/ui-kit/MessageInputKit.jsx";
import Buttons from "../components/ui-kit/Buttons.jsx";

export default function UIKitPage() {
  return (
    <div style={{ padding: 32 }}>
      <h1>UI Kit</h1>
      <Colors />
      <Shadows />
      <Fonts />
      <Icons />
      <Buttons />
      <MessageInputKit />
    </div>
  );
}
